(() => {
  'use strict';

  let pendingAdd = null;

  function rememberProductAdd(event) {
    const cardButton = event.target.closest('[data-jf-card-atc]');
    if (cardButton) {
      pendingAdd = {
        productId: cardButton.dataset.jfProductId || '',
        productTitle: cardButton.dataset.jfProductTitle || '',
        variantId: cardButton.dataset.jfVariantId || '',
        quantity: 1,
        url: cardButton.closest('a[href]')?.href || window.location.href,
      };
      return;
    }

    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const productRoot = form.closest('ce-product');
    const formData = new FormData(form);
    pendingAdd = {
      productId: productRoot?.dataset.jfProductId || '',
      productTitle: productRoot?.dataset.jfProductTitle || document.title,
      variantId: String(formData.get('id') || productRoot?.getAttribute('variant-id') || ''),
      quantity: Number(formData.get('quantity') || 1),
      url: window.location.href,
    };
  }

  function isIndividualJuiceCollection() {
    const path = window.location.pathname.replace(/\/+$/, '');
    return path === '/collections/jugos' || path.endsWith('/collections/jugos');
  }

  function openCartDrawer() {
    // Keep the customer on the juice collection so several individual juices
    // can be added without closing the drawer after every selection.
    if (isIndividualJuiceCollection()) return;

    window.setTimeout(() => {
      const drawer = document.querySelector('ce-cart-drawer');
      if (!drawer || drawer.getAttribute('is-open') === 'true') return;

      const opener = document.querySelector('[data-cart-drawer-button-open]');
      if (opener) opener.click();
      else if (typeof drawer.handleClickButtonOpen === 'function') drawer.handleClickButtonOpen();
    }, 120);
  }

  async function trackSuccessfulAdd() {
    if (!pendingAdd) return;

    let cart = null;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (response.ok) cart = await response.json();
    } catch (error) {
      // Tracking must never interrupt the shopping experience.
    }

    const addedItem = cart?.items?.find((item) => String(item.variant_id) === String(pendingAdd.variantId));
    const value = addedItem ? (addedItem.final_line_price / 100) : undefined;
    const currency = window.Shopify?.currency?.active || cart?.currency || 'MXN';

    const klaviyoPayload = {
      ProductName: pendingAdd.productTitle,
      ProductID: pendingAdd.productId,
      VariantID: pendingAdd.variantId,
      Quantity: pendingAdd.quantity,
      URL: pendingAdd.url,
      $value: value,
      CartTotal: cart ? cart.total_price / 100 : undefined,
      Items: cart?.items || [],
    };

    window._learnq = window._learnq || [];
    window._learnq.push(['track', 'Added to Cart', klaviyoPayload]);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency,
        value,
        items: [{
          item_id: String(pendingAdd.variantId),
          item_name: pendingAdd.productTitle,
          quantity: pendingAdd.quantity,
          price: addedItem ? addedItem.final_price / 100 : undefined,
        }],
      },
    });

    pendingAdd = null;
  }

  document.addEventListener('click', rememberProductAdd, true);
  document.addEventListener('submit', rememberProductAdd, true);
  document.addEventListener('Themu:cart:add', () => {
    openCartDrawer();
    trackSuccessfulAdd();
  });
})();
